var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"重置密码","centered":"","visible":_vm.visible,"cancelText":"取消","okText":"确定"},on:{"ok":_vm.onSubmit,"cancel":function () {
      _vm.form.resetFields();
      _vm.$emit('cancel');
    }}},[_c('a-form',{attrs:{"form":_vm.form}},[_c('a-form-item',{attrs:{"label":"重置密码","label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'newPassword',
          {
            rules: [
              { required: true, message: '重置密码不能为空' },
              {
                pattern: /^[a-zA-Z0-9]{6,16}$/,
                message: '重置密码不正确，6-16位的数字、字母、或数字字母组合，区分大小写'
              }
            ],
            validateTrigger: 'blur',
            getValueFromEvent: function (event) { return event.target.value.trim(); }
          }
        ]),expression:"[\n          'newPassword',\n          {\n            rules: [\n              { required: true, message: '重置密码不能为空' },\n              {\n                pattern: /^[a-zA-Z0-9]{6,16}$/,\n                message: '重置密码不正确，6-16位的数字、字母、或数字字母组合，区分大小写'\n              }\n            ],\n            validateTrigger: 'blur',\n            getValueFromEvent: event => event.target.value.trim()\n          }\n        ]"}],attrs:{"placeholder":"6-16位的数字、字母、或数字字母组合","maxlength":16}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }